
export enum UserRole {
  MASTER_ADMIN = 'MASTER_ADMIN',
  ADMIN = 'ADMIN',
  VIEW_ONLY_ADMIN = 'VIEW_ONLY_ADMIN',
  REPRESENTATIVE = 'REPRESENTATIVE',
  BUS_DRIVER = 'BUS_DRIVER',
  PAYMENT_ADMIN = 'PAYMENT_ADMIN',
}

export interface BusStudent {
  studentId: string; // The generated student ID or unique identifier (e.g. serialNo or id)
  studentName: string;
  parentName?: string;
  phone?: string;
  surveyId: string; // Reference to the survey
  status: 'PENDING' | 'BOARDED' | 'DROPPED_OFF';
  boardedAt?: string;
  droppedOffAt?: string;
}

export interface BusJourney {
  id: string;
  driverId: string;
  driverName: string;
  date: string; // YYYY-MM-DD
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED';
  startedAt?: string;
  completedAt?: string;
  students: BusStudent[];
  currentLocation?: {
    lat: number;
    lng: number;
    timestamp: string;
    speed?: number;
  };
}

export interface User {
  id: string; // Firebase UID
  username: string; // Used for email construction (username@samajam.app)
  role: UserRole;
  name: string;
  visibleSections?: string[]; // IDs of allowed sections
  isActive?: boolean; // For status management
  vehicleDetails?: {
    model: string;
    color: string;
    registration: string;
  };
}

export interface SurveySection {
  id: string;
  label: string;
  isRepeater?: boolean; // If true, allows adding multiple entries (like Family Members)
  order: number;
}

export interface DynamicQuestion {
  id: string;
  label: string;
  type: 'text' | 'number' | 'yesno' | 'dropdown' | 'textarea' | 'multiselect' | 'image' | 'date';
  section: string; // Changed from hardcoded union to string to support dynamic sections
  options?: string[]; // For dropdown/multiselect
  required?: boolean;
  dependsOn?: string; // ID of the question this depends on
  visibleIf?: string | boolean | string[]; // Value(s) that make this visible
}

export interface SurveyData {
  id: string;
  submittedBy: string;
  submittedAt: string;
  paymentStatus?: 'Pending' | 'Paid';
  paymentAmount?: number;
  paidBy?: string;
  paidAt?: string;
  // We use index signature to allow dynamic section keys
  // Legacy support: sectionA, sectionB, etc. are still used as IDs
  [key: string]: any; 
}

export interface CardField {
  key: string;
  label: string;
  x: number;
  y: number;
  fontSize: number;
  color: string;
  fontFamily?: string;
  alignment?: 'left' | 'center' | 'right';
}

export interface CardTemplate {
  backgroundImage: string;
  fields: CardField[];
  photoConfig?: null | {
    x: number;
    y: number;
    width: number;
    height: number;
  };
}
export interface AttendanceRecord {
  id: string;
  date: string;
  studentId: string;
  studentName: string;
  inTime?: string;
  outTime?: string;
  status: 'PRESENT' | 'ABSENT' | 'LATE';
  isStaff?: boolean;
  staffRole?: string;
}

export interface StaffMember {
  id: string;
  serialNo: string;
  name: string;
  phone: string;
  whatsapp: string;
  photo: string;
  role: 'faculty' | 'coordinator';
  submittedAt: string;
}

